import { defineMessages } from "react-intl";

export const messages = defineMessages({
    chartsTitle: {
        id: "charts.title",
        defaultMessage: "Charts",
    },
    chartsNoRows: {
        id: "charts.no-rows",
        defaultMessage: "There are no rows for this chart.",
    },
    numberStreams: {
        id: "charts.num-streams",
        defaultMessage: `{number} {total, plural,
            =0 {streams}
            one {stream}
            other {streams}
        }`,
    },
    numberDownloads: {
        id: "charts.num-downloads",
        defaultMessage: `{number} {total, plural,
            =0 {downloads}
            one {download}
            other {downloads}
        }`,
    },
    chartNewReleasesPopoverTitle: {
        id: "charts.new-releases-popover-title",
        defaultMessage: `New releases`,
    },
    chartNewReleasesDescription: {
        id: "charts.new-releases-description",
        defaultMessage: `New releases are defined as products released within 8 weeks of the selected date period.`,
    },
    chartsStreamTracksWeek: {
        id: "charts.chart.stream-tracks-week",
        defaultMessage: "Most streamed tracks of the week",
    },
    chartsStreamTracksAllTime: {
        id: "charts.chart.stream-tracks-alltime",
        defaultMessage: "Most streamed tracks of all time",
    },
    chartsDownloadTracksWeek: {
        id: "charts.chart.download-tracks-week",
        defaultMessage: "Most downloaded tracks of the week",
    },
    chartsDownloadTracksAllTime: {
        id: "charts.chart.download-tracks-alltime",
        defaultMessage: "Most downloaded tracks of all time",
    },
    chartsDownloadAlbumsWeek: {
        id: "charts.chart.download-albums-week",
        defaultMessage: "Most downloaded products of the week",
    },
    chartsDownloadAlbumsAllTime: {
        id: "charts.chart.download-albums-alltime",
        defaultMessage: "Most downloaded products of all time",
    },
    chartStreamTracksPeriod: {
        id: "charts.chart.stream-tracks-period",
        defaultMessage: "Most streamed tracks",
    },
    chartStreamNewReleasesPeriod: {
        id: "charts.chart.stream-newreleases-period",
        defaultMessage: "Most streamed new releases",
    },
    chartDownloadTracksPeriod: {
        id: "charts.chart.download-tracks-period",
        defaultMessage: "Most downloaded tracks",
    },
    chartDownloadAlbumsPeriod: {
        id: "charts.chart.download-albums-period",
        defaultMessage: "Most downloaded products",
    },
    chartPreordersPeriod: {
        id: "charts.chart.preorders-period",
        defaultMessage: "Most pre-ordered products",
    },
    chartStreamArtistsPeriod: {
        id: "charts.chart.stream-artists-period",
        defaultMessage: "Most streamed artists",
    },
});
